import React from "react";
import {
  Navigation,
  Page,
  Storage,
  TaskMultiChoice,
  TaskMultiSelect,
  TaskSorting,
  Figure
} from "@bittnerdevelopmentgroup/interactive";
import { Row, Col } from "react-bootstrap"
import refrigerator from "./assets/components-gdp-04.jpg"
import shippingCrates from "./assets/components-gdp-02.jpg"
import congressBuilding from "./assets/components-gdp-03.jpg"
import construction from "./assets/components-gdp-01.jpg"

import Int_PrinEco4_19_1_Custom from "./assets/Int_PrinEco4_19-1_Custom.jpg"
import Int_PrinEco4_19_2_Custom from "./assets/Int_PrinEco4_19-2_Custom.jpg"
import Int_PrinEco4_19_3_Custom from "./assets/Int_PrinEco4_19-3_Custom.jpg"
import Int_PrinEco4_19_4_Custom from "./assets/Int_PrinEco4_19-4_Custom.jpg"
import Int_PrinEco4_19_5_Custom from "./assets/Int_PrinEco4_19-5_Custom.jpg"

import Int_PrinEco4_19_0a_Custom from "./assets/Int_PrinEco4_19-0a_Custom.jpg"
import Int_PrinEco4_19_0b_Custom from "./assets/Int_PrinEco4_19-0b_Custom.jpg"
import Int_PrinEco4_19_0c_Custom from "./assets/Int_PrinEco4_19-0c_Custom.jpg"
import Int_PrinEco4_19_0d_Custom from "./assets/Int_PrinEco4_19-0d_Custom.jpg"

import "./styles.css"

class ComponentsGDP extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showFeedback: true
    }
  }

  render() {
    return (
      <div className="components-gdp">
        <div className="sr-only" aria-hidden="true">
          {[refrigerator, shippingCrates, congressBuilding, construction, 
            Int_PrinEco4_19_1_Custom, Int_PrinEco4_19_2_Custom, Int_PrinEco4_19_3_Custom, Int_PrinEco4_19_4_Custom, Int_PrinEco4_19_5_Custom,
            Int_PrinEco4_19_0a_Custom, Int_PrinEco4_19_0b_Custom, Int_PrinEco4_19_0c_Custom, Int_PrinEco4_19_0d_Custom].map(src => <img alt="" src={src} />)}
        </div>
        <Navigation interactiveId="chapter-19b">
          <Page>
            <p>
              <b>Gross domestic product (GDP)</b> is the dollar value of all final goods and services produced within a country’s 
              borders in a year. GDP is calculated by adding up the production by category. The following formula is used for calculating 
              GDP. Each variable represents a different category of expenditure. 
            </p>
            <img
                alt="A graphic illustrating the equation, C plus I plus G plus N X equals G D P."
                src={Int_PrinEco4_19_1_Custom}
                style={{width: "100%"}}
              />
            <p>
              <b>Make a prediction: what does the letter <i>C</i> stand for?</b>
            </p>
            <Row>
              <Col xs={3}>
                <img
                  alt="An illustration of a blue square with the letter C in the middle."
                  src={Int_PrinEco4_19_0a_Custom}
                  style={{width: "100%"}}
                />
              </Col>
              <Col>
                <TaskMultiChoice
                  state={Storage()}
                  prompt={<span className="sr-only">Choices for what the letter C stands for.</span>}
                  choices={[
                    "capital goods", 
                    "checkable deposits", 
                    "consumption",
                    "crime",
                  ]}
                  correct={[2]}
                  feedback={[
                    "Capital goods are actually included in a different category of the GDP.",
                    "Checkable deposits are a component of the money supply, but they are not in the equation for GDP.",
                    <><b>Consumption</b> is the purchase of final goods and services by households, with the exception of new housing, and it’s about two-thirds of GDP.</>,
                    "Crime can affect various categories of GDP, but it is not part of the equation.",
                  ]}
                  randomize={false}
                />
              </Col>
            </Row>
          </Page>
          <Page>
            <img
              alt="A graphic illustrating the equation, consumption plus I plus G plus N X equals G D P."
              src={Int_PrinEco4_19_2_Custom}
              style={{width: "100%"}}
            />
            <p>
              <b>Make a prediction: what does the letter <i>I</i> stand for?</b>
            </p>
            <Row>
              <Col xs={3}>
                <img
                  alt="An illustration of a red square with the letter I in the middle."
                  src={Int_PrinEco4_19_0b_Custom}
                  style={{width: "100%"}}
                />
              </Col>
              <Col>
                <TaskMultiChoice
                  state={Storage()}
                  prompt={<span className="sr-only">Choices for what the letter I stands for.</span>}
                  choices={[
                    "investment",
                    "income",
                    "immigration",
                    "indirect cost",
                  ]}
                  correct={[0]}
                  feedback={[
                    <><b>Investment</b> is private spending on the tools, plant, and equipment used to produce future output.</>,
                    "Income is not part of the equation for GDP.",
                    "Immigration has an effect on GDP, but it is not part of the equation.",
                    "Indirect costs are not part of the equation for GDP.",
                  ]}
                  randomize={false}
                />
              </Col>
            </Row>
          </Page>
          <Page>
            <img
              alt="A graphic illustrating the equation, consumption plus investment plus G plus N X equals G D P."
              src={Int_PrinEco4_19_3_Custom}
              style={{width: "100%"}}
            />
            <p>
              <b>Make a prediction: what does the letter <i>G</i> stand for?</b>
            </p>
            <Row>
              <Col xs={3}>
                <img
                  alt="An illustration of a yellow square with the letter G in the middle."
                  src={Int_PrinEco4_19_0c_Custom}
                  style={{width: "100%"}}
                />
              </Col>
              <Col>
                <TaskMultiChoice
                  state={Storage()}
                  prompt={<span className="sr-only">Choices for what the letter G stands for.</span>}
                  choices={[
                    "GDP deflator",
                    "globalization",
                    "growth",
                    "government spending",
                  ]}
                  correct={[3]}
                  feedback={[
                    <>The GDP deflator is a measure of the price level used to calculate real GDP. In other words, we use the GDP deflator <i>after</i> adding together all the categories in this equation.</>,
                    "Globalization has an effect on GDP, but it’s not part of this equation.",
                    "We can see growth when comparing GDP year to year. However, first we have to do this initial calculation.",
                    <><b>Government spending</b> includes spending by all levels of government on final goods and services.</>,
                  ]}
                  randomize={false}
                />
              </Col>
            </Row>
          </Page>
          <Page>
            <img
              alt="A graphic illustrating the equation, consumption plus investment plus government spending plus N X equals G D P."
              src={Int_PrinEco4_19_4_Custom}
              style={{width: "100%"}}
            />
            <p>
              <b>Make a prediction: what do the letters <i>NX</i> stand for?</b>
            </p>
            <Row>
              <Col xs={3}>
                <img
                  alt="An illustration of a green square with the letters N X in the middle."
                  src={Int_PrinEco4_19_0d_Custom}
                  style={{width: "100%"}}
                />
              </Col>
              <Col>
                <TaskMultiChoice
                  state={Storage()}
                  prompt={<span className="sr-only">Choices for what the letter NX stands for.</span>}
                  choices={[
                    "negative exchange rate",
                    "net exports",
                    "new equilibrium",
                    "national exposure",
                  ]}
                  correct={[1]}
                  feedback={[
                    "This is not part of the GDP equation. Hint: The term you’re looking for has to do with international trade.",
                    <><b>Net exports</b> are the total exports of final goods and services minus total imports of final goods and services.</>,
                    "This is not part of the GDP equation. Hint: The term you’re looking for has to do with international trade.",
                    "This is not part of the GDP equation. Hint: The term you’re looking for has to do with international trade.",
                  ]}
                  randomize={false}
                />
              </Col>
            </Row>
          </Page>
          <Page>
            <TaskSorting
              state={Storage()}
              feedbackCorrect="Yes! All of these are examples of GDP components. But what about net exports? We’ll review that in the following panel."
              feedbackIncorrect="Remember that consumption is the purchase of final goods and services by households, excluding new housing; investment is private spending on the tools, plant, and equipment used to produce future output; and government spending includes spending by all levels of government on final goods and services."
              prompt={
              <>
                <p>
                  The following are examples of expenditures.&nbsp;<b>Which category do you think they belong in?</b>
                </p>
                <p>
                  <i>
                    Drag the appropriate image to its category in the formula.
                  </i>
                </p>
                <p>
                  <img
                    alt="A graphic illustrating the equation, consumption plus investment plus government spending plus net exports equals G D P."
                    src={Int_PrinEco4_19_5_Custom}
                    style={{width: "100%"}}
                  />
                </p>
              </>}
              categories={[
                "Consumption",
                "Investment",
                "Government Spending",
              ]}
            >
              <TaskSorting.Option category={0}> 
                <Figure
                  alt="A photo of eggs, fruit, and vegetables in a fridge."
                  caption="Buying groceries for the week"
                  src={refrigerator}
                  style={{width: "196px"}}
                  photoCredit="okanmetin/Getty Images"
                  className="sorting-figure"
                />
              </TaskSorting.Option>
              <TaskSorting.Option category={2}> 
                <Figure
                  alt="A photo of the American flag flying next to the dome of the U S Capitol building."
                  caption="Maintenance of the Capitol building"
                  src={congressBuilding}
                  style={{width: "196px"}}
                  photoCredit="ajansen/Getty Images"
                  className="sorting-figure"
                />
              </TaskSorting.Option>
              <TaskSorting.Option category={1}> 
                <Figure
                  alt="A photo of a backhoe"
                  caption="Building a new hospital"
                  longAlt={"A photo of a backhoe. It is a large vehicle for construction with a narrow shovel on a long arm in back and a wide scooper bucket in front."}
                  src={construction}
                  style={{width: "196px"}}
                  photoCredit="1001nights/Getty Images"
                  className="sorting-figure"
                />
              </TaskSorting.Option>
            </TaskSorting>
          </Page>
          <Page>
            <p>
              Let’s review <b>net exports</b>, which are total exports minus imports.
            </p>
            <p>
              Since GDP is the market value of all final goods and services produced <i>within</i> a country, 
              what do you think happens to GDP when we import goods from <i>outside</i> the country?
            </p>
            <img
              alt="A graphic illustrating the equation, consumption plus investment plus government spending plus net exports equals G D P."
              src={Int_PrinEco4_19_5_Custom}
              style={{width: "100%"}}
            />
            <TaskMultiSelect
              state={Storage()}
              prompt={
              <>
                <p>
                  <b>If the United States imports $10 billion worth of bananas from Guatemala, how does that impact the GDP?</b> (Hint: This affects two different categories of expenditures.)
                </p>
                <div>
                  <i>Select all that apply.</i>
                </div>
              </>}
              data={[
                {
                  label: <span>Government spending decreases by $10 billion.</span>,
                  correct: false,
                },
                { 
                  label: <span>Investment increases by $10 billion.</span>, 
                  correct: false 
                },
                { 
                  label: <span>Consumption increases by $10 billion.</span>, 
                  correct: true 
                },
                {
                  label: <span>Net exports decrease by $10 billion.</span>,
                  correct: true,
                },
              ]}
              correctFeedback={
                <span>
                  Imports of the $10 billion worth of bananas are subtracted from net exports (NX) 
                  but are offset by an increase of consumption (C) of $10 billion. There is no overall impact on GDP due solely 
                  to importing goods.
                </span>
              }
              incorrectFeedback={
                <span>
                  Think about the four components of GDP. Imported consumer goods, like bananas from Guatemala, 
                  will increase one of these components of GDP, but because they are produced abroad, they also 
                  reduce another component of GDP. Make sure you select both components that change.
                </span>
              }
            />
          </Page>
        </Navigation>
      </div>
    )
  }
}

export default ComponentsGDP
